/* Custom Quiz — "Build my box" 3-step flow.
   Step 1: pool type → Step 2: pool size → Step 3: matching box result.
   Size options are only offered when a result block exists for the chosen type. */

(function () {
  function initQuiz(root) {
    var state = { type: null, size: null };
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var results = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-result]'));
    var sizeOptions = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-option="size"]'));
    var cta = root.querySelector('[data-quiz-cta]');
    var currentStep = 1;

    function goTo(n, push) {
      currentStep = n;
      steps.forEach(function (step) {
        step.hidden = step.getAttribute('data-quiz-step') !== String(n);
      });
      if (n === 3) showResult();
      if (push !== false) {
        try {
          history.pushState({ poolblyQuiz: n }, '');
        } catch (e) {
          /* history may be unavailable in some embedded contexts */
        }
      }
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    function hasResult(type, size) {
      return results.some(function (panel) {
        return panel.getAttribute('data-type') === type && panel.getAttribute('data-size') === size;
      });
    }

    function selectOption(option, selected) {
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-checked', selected ? 'true' : 'false');
    }

    function syncSizeOptions() {
      var step = root.querySelector('[data-quiz-step="2"]');
      var continueButton = step.querySelector('[data-quiz-continue]');
      var selectionStillValid = false;

      sizeOptions.forEach(function (option) {
        var available = hasResult(state.type, option.getAttribute('data-value'));
        option.hidden = !available;
        if (!available && option.classList.contains('is-selected')) selectOption(option, false);
        if (available && option.classList.contains('is-selected')) selectionStillValid = true;
      });

      if (!selectionStillValid) {
        state.size = null;
        if (continueButton) continueButton.disabled = true;
      }
    }

    function showResult() {
      var match =
        results.filter(function (panel) {
          return panel.getAttribute('data-type') === state.type && panel.getAttribute('data-size') === state.size;
        })[0] ||
        results.filter(function (panel) {
          return panel.getAttribute('data-type') === state.type;
        })[0] ||
        results[0];

      results.forEach(function (panel) {
        panel.hidden = panel !== match;
      });

      if (cta && match && match.getAttribute('data-cta-url')) {
        cta.setAttribute('href', match.getAttribute('data-cta-url'));
      }
    }

    root.querySelectorAll('[data-quiz-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var key = option.getAttribute('data-quiz-option');
        var step = option.closest('[data-quiz-step]');

        state[key] = option.getAttribute('data-value');

        step.querySelectorAll('[data-quiz-option="' + key + '"]').forEach(function (other) {
          selectOption(other, other === option);
        });

        var continueButton = step.querySelector('[data-quiz-continue]');
        if (continueButton) continueButton.disabled = false;

        if (key === 'type') syncSizeOptions();
      });
    });

    root.querySelectorAll('[data-quiz-continue]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(button.closest('[data-quiz-step]').getAttribute('data-quiz-step'));
        goTo(Math.min(step + 1, 3));
      });
    });

    root.querySelectorAll('[data-quiz-goto]').forEach(function (link) {
      link.addEventListener('click', function () {
        goTo(Number(link.getAttribute('data-quiz-goto')));
      });
    });

    root.querySelectorAll('[data-quiz-help-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var text = button.parentElement.querySelector('.custom-quiz__help-text');
        if (!text) return;
        text.hidden = !text.hidden;
        button.setAttribute('aria-expanded', text.hidden ? 'false' : 'true');
      });
    });

    root.querySelectorAll('[data-quiz-expand]').forEach(function (button) {
      button.addEventListener('click', function () {
        var list = button.parentElement.querySelector('[data-quiz-list]');
        if (list) list.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        button.hidden = true;
      });
    });

    window.addEventListener('popstate', function (event) {
      var target = event.state && event.state.poolblyQuiz;
      if (target) {
        goTo(target, false);
      } else if (currentStep > 1) {
        goTo(1, false);
      }
    });

    try {
      history.replaceState({ poolblyQuiz: 1 }, '');
    } catch (e) {
      /* noop */
    }
  }

  document.querySelectorAll('[data-custom-quiz]').forEach(initQuiz);
})();
